import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Amount } from '@fcom/dapi/interfaces';

@Component({
  selector: 'fin-ancillary-price',
  templateUrl: 'ancillary-price.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AncillaryPriceComponent {
  @Input() price: Amount;
  @Input() title: string;
  @Input() disclaimer: string;
}
